import { defineMessages } from 'react-intl';

import {
  type ApplyRewardErrorCode,
  type ApplyRewardGenericErrorCode,
} from './useApplyRewardErrorMessage.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const genericMessages = defineMessages<ApplyRewardGenericErrorCode>({
  NETWORK_ERROR: {
    defaultMessage:
      'Something went wrong with the reward. Please try to apply the reward again.',
    description: 'Loyalty | Apply reward generic error message | NETWORK_ERROR',
  },
  REWARD_MULTIPLE_ERRORS: {
    defaultMessage:
      'This order might not meet the conditions of the reward selected, so it will not be applied at checkout.',
    description:
      'Loyalty | Apply reward generic error message | REWARD_MULTIPLE_ERRORS',
  },
});

export const fallbackMessages = defineMessages<ApplyRewardErrorCode>({
  NETWORK_ERROR: {
    defaultMessage:
      'Something went wrong with the reward. Please try to apply the reward again.',
    description: 'Loyalty | Apply reward error message | NETWORK_ERROR',
  },
  REWARD_MULTIPLE_ERRORS: {
    defaultMessage:
      'This order might not meet the conditions of the reward selected, so it will not be applied at checkout.',
    description:
      'Loyalty | Apply reward error message | REWARD_MULTIPLE_ERRORS',
  },
  REWARD_NOT_APPLICABLE: {
    defaultMessage:
      'This order might not meet the conditions of the reward selected, so it will not be applied at checkout.',
    description: 'Loyalty | Apply reward error message | REWARD_NOT_APPLICABLE',
  },
  REWARD_EXPIRED: {
    defaultMessage:
      'Your selected reward has expired and will not be applied at checkout.',
    description: 'Loyalty | Apply reward error message | REWARD_EXPIRED',
  },
  REWARD_NOT_FOUND: {
    defaultMessage:
      'We were unable to apply your selected reward, so it will not be applied at checkout.',
    description: 'Loyalty | Apply reward error message | REWARD_NOT_FOUND',
  },
  RESTAURANT_NOT_ACCEPTING_ORDERS: {
    defaultMessage:
      'Online ordering is currently unavailable at this location.',
    description:
      'Loyalty | Apply reward error message | RESTAURANT_NOT_ACCEPTING_ORDERS',
  },
  MISSING_SKU: {
    defaultMessage:
      'This order does not meet the conditions of the reward selected, please add required item to apply the reward.',
    description: 'Loyalty | Apply reward error message | MISSING_SKU',
  },
  PRICE_MINIMUM: {
    defaultMessage:
      'This order does not meet the price minimum of the reward selected, please adjust your cart to apply the reward.',
    description: 'Loyalty | Apply reward error message | PRICE_MINIMUM',
  },
  PRICE_MAXIMUM: {
    defaultMessage:
      'This order does not meet the price maximum of the reward selected, please adjust your cart to apply the reward.',
    description: 'Loyalty | Apply reward error message | PRICE_MAXIMUM',
  },
  TIME_RESTRICTION: {
    defaultMessage:
      'This order does not meet the time restriction(s) of the reward selected.',
    description: 'Loyalty | Apply reward error message | TIME_RESTRICTION',
  },
  CHANNEL_RESTRICTION: {
    defaultMessage:
      'This order does not meet the conditions of the reward selected, please switch to a (channel) order to apply the reward.',
    description: 'Loyalty | Apply reward error message | CHANNEL_RESTRICTION',
  },
  DAY_RESTRICTION: {
    defaultMessage:
      'This offer is valid to redeem on (days). Please apply this reward on a valid day.',
    description: 'Loyalty | Apply reward error message | DAY_RESTRICTION',
  },
});

export const daysOfTheWeekMessages = defineMessages({
  monday: {
    defaultMessage: 'Monday',
    description: 'Loyalty | Apply reward | Day of the week | Monday',
  },
  tuesday: {
    defaultMessage: 'Tuesday',
    description: 'Loyalty | Apply reward | Day of the week | Tuesday',
  },
  wednesday: {
    defaultMessage: 'Wednesday',
    description: 'Loyalty | Apply reward | Day of the week | Wednesday',
  },
  thursday: {
    defaultMessage: 'Thursday',
    description: 'Loyalty | Apply reward | Day of the week | Thursday',
  },
  friday: {
    defaultMessage: 'Friday',
    description: 'Loyalty | Apply reward | Day of the week | Friday',
  },
  saturday: {
    defaultMessage: 'Saturday',
    description: 'Loyalty | Apply reward | Day of the week | Saturday',
  },
  sunday: {
    defaultMessage: 'Sunday',
    description: 'Loyalty | Apply reward | Day of the week | Sunday',
  },
});
